import RouteNames from "@/entities/RouteNames";
import NavigationIcons from "@/entities/NavigationIcons";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const JobBoardApplications = () =>
  import("@/views/jobboard/JobBoardApplications.vue").then((m) => m.default);
const Postings = () =>
  import("@/views/jobboard/Postings.vue").then((m) => m.default);
const ContractorPostingsTabs = () =>
  import("@/views/jobboard/ContractorPostingsTabs.vue").then((m) => m.default);
const Posting = () =>
  import("@/views/jobboard/PostingV2.vue").then((m) => m.default);

const getPostingsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/jobboard/postings",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.JOB_BOARD,
        routeName: RouteNames.JOBBOARD_POSTINGS_MARKETPLACE,
        copyLink: false,
        isStyled: true,
      },
    },
  },
]);

const getApplicationsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/jobboard/applications",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.APPLICATIONS,
        icon: NavigationIcons.APPLICATIONS,
        routeName: RouteNames.JOBBOARD_APPLICATIONS,
        copyLink: true,
      },
    },
    children: [
      {
        path: "",
        component: JobBoardApplications,
        name: RouteNames.JOBBOARD_APPLICATIONS,
        meta: {
          roles: [Roles.CONTRACTOR],
        },
      },
    ],
  },
]);

const getMarketPlacePostingsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "marketplace",
    name: RouteNames.JOBBOARD_POSTINGS_MARKETPLACE,
    component: Postings,
    meta: {
      title: "Marketplace postings",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        routeName: RouteNames.JOBBOARD_POSTING,
        title: BreadcrumbsTitles.POSTING,
        isStyled: true,
        copyLink: false,
      }
    },
    props: { isMarketplace: true },
  },
]);

const getCompanyPostingsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "internal",
    name: RouteNames.JOBBOARD_POSTINGS_INTERNAL,
    component: Postings,
    meta: {
      title: "Internal postings",
      roles: [Roles.CONTRACTOR],
    breadcrumb: {
      title: BreadcrumbsTitles.POSTING,
      isStyled: true,
      copyLink: false,
    }
  },
    props: { isMarketplace: false },
  },
]);

const getPostingsTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    component: ContractorPostingsTabs,
    name: RouteNames.JOBBOARD_POSTINGS,
    redirect: {
      name: RouteNames.JOBBOARD_POSTINGS_MARKETPLACE,
    },
    meta: {
      roles: [Roles.CONTRACTOR],
    },
  },
]);

const getPostingPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: ":id",
    name: RouteNames.JOBBOARD_POSTING,
    component: Posting,
    meta: {
      title: "Posting",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        title: BreadcrumbsTitles.POSTING,
        isStyled: true,
      },
    },
  },
]);

export {
  getMarketPlacePostingsRoutes,
  getCompanyPostingsRoutes,
  getPostingsTabsRoutes,
  getPostingPrivatePageRoutes,
  getApplicationsRoutes,
  getPostingsRoutes,
};
